module.exports = __webpack_public_path__ + "assets/img/christophe.fb06260a.png";